import IResult from "../../../shared/models/result/IResult";
import {
    sendGetWithCustomHeaders,
    sendPostWithCustomHeaders,
    sendPutWithCustomHeaders
} from "../../../shared/api/controllers/generic";

export interface OnboardingApiClient {
    get<T>(url: string, signal?: AbortSignal): Promise<IResult<T>>;
    post<T>(url: string, body: any): Promise<IResult<T>>;
    put<T>(url: string, body?: any): Promise<IResult<T>>;
}

export const createOnboardingApiClient = (apiKey: string, baseUrl?: string): OnboardingApiClient => {
    const headers = { 'X-Api-Key': apiKey };

    return {
        get: <T>(url: string, signal?: AbortSignal) =>
            sendGetWithCustomHeaders<T>(url, headers, baseUrl, signal),
        post: <T>(url: string, body: any) =>
            sendPostWithCustomHeaders<T>(url, body, headers, baseUrl),
        put: <T>(url: string, body?: any) =>
            sendPutWithCustomHeaders<T>(url, body, headers, baseUrl)
    };
};
